/* src/app/core/progress-spinner/progress-spinner.component.scss */
.progress-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(255, 255, 255, 0.55);
  outline: none;
}
.progress-overlay-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/*# sourceMappingURL=progress-spinner.component.css.map */
